import { _ACTIVITIES } from "../constants";

export const OTHER_SUNDRY_EXPS = "OTHER SUNDRY EXPS.";
export const HIRE_OF_EQUIPMENT_INCOME = "HIRE OF EQUIPMENT (Income)";

export const LINKED_HIRE_EQUIPMENT_DATA = [
  {
    activity: _ACTIVITIES.LRU,
    theme: [
      { name: OTHER_SUNDRY_EXPS, quantity: 1 },
      { name: HIRE_OF_EQUIPMENT_INCOME, quantity: 1 },
    ],
  },
];
export const SAVE_CATEGORY_HIRE_EQUIPMENT = "hire_equipment";
